import type { SubdivisionCatalog } from "./types";

/** Argentina — 23 provinces plus the autonomous city, which ISO lists as a subdivision of its own. */
export const ARG_SUBDIVISIONS: SubdivisionCatalog = [
  { code: "AR-B", name: "Buenos Aires" },
  { code: "AR-K", name: "Catamarca" },
  { code: "AR-H", name: "Chaco" },
  { code: "AR-U", name: "Chubut" },
  // `AR-C` is the city, `AR-B` the province that surrounds it — two different answers to "Buenos Aires".
  { code: "AR-C", name: "Ciudad Autónoma de Buenos Aires", aliases: ["CABA", "Capital Federal"] },
  { code: "AR-X", name: "Córdoba" },
  { code: "AR-W", name: "Corrientes" },
  { code: "AR-E", name: "Entre Ríos" },
  { code: "AR-P", name: "Formosa" },
  { code: "AR-Y", name: "Jujuy" },
  { code: "AR-L", name: "La Pampa" },
  { code: "AR-F", name: "La Rioja" },
  { code: "AR-M", name: "Mendoza" },
  { code: "AR-N", name: "Misiones" },
  { code: "AR-Q", name: "Neuquén" },
  { code: "AR-R", name: "Río Negro" },
  { code: "AR-A", name: "Salta" },
  { code: "AR-J", name: "San Juan" },
  { code: "AR-D", name: "San Luis" },
  { code: "AR-Z", name: "Santa Cruz" },
  { code: "AR-S", name: "Santa Fe" },
  { code: "AR-G", name: "Santiago del Estero" },
  // Constitutional name — "Tierra del Fuego, Antártida e Islas del Atlántico Sur" — is 53 chars and would
  // not fit the address field. The ISO list name is the short one.
  { code: "AR-V", name: "Tierra del Fuego", aliases: ["Antártida"] },
  { code: "AR-T", name: "Tucumán" },
];
